import React, { useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Checkbox,
  Button as MuiButton,
} from "@mui/material";
import CloseLineIcon from "remixicon-react/CloseLineIcon";
import clsx from "clsx";
import { Text } from "$components";
import { useCategoryForm } from "./context/CategoryFormContext";
import useStyles from "./styles";
import { isReferencingCategoryName } from "$hooks/useCategoriesQuery";

export const CategoryFormParentCategory: React.FC = () => {
  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext();
  const classes = useStyles();

  const {
    categories,
    category,
    selectedCategory,
    setSelectedCategory,
    parentSelectedCategory,
    setParentSelectedCategory,
  } = useCategoryForm();

  const handleRemoveCategory = (): void => {
    setSelectedCategory("");
  };

  useEffect(() => {
    setValue("category", selectedCategory, { shouldValidate: true });
    setParentSelectedCategory("");
    categories.map((c: any) => {
      if (c.id === selectedCategory)
        setParentSelectedCategory(c.parentCategoryId);
      return c;
    });
  }, [categories, selectedCategory, setParentSelectedCategory, setValue]);

  const filteredCategories = categories.filter(
    (c: any) => !isReferencingCategoryName(c.title?.toUpperCase())
  );

  return (
    <Controller
      name="category"
      control={control}
      render={({ field }) => (
        <FormControl variant="filled" className={classes.select}>
          <InputLabel id="demo-simple-select-filled-label">
            Catégorie de rattachement
          </InputLabel>
          <Select
            labelId="demo-simple-select-filled-label"
            id="demo-simple-select-dfesfsef"
            MenuProps={{
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "left",
              },
            }}
            variant="outlined"
            renderValue={() => {
              if (!selectedCategory) {
                return "Sélectionnez la catégorie de rattachement";
              }
              const selectedCat = categories.find(
                (c: any) => c.id === selectedCategory
              );
              return selectedCat
                ? selectedCat.title
                : "Sélectionnez la catégorie de rattachement";
            }}
            data-placeholder-show-label={!selectedCategory.length}
            {...field}
            onChange={(e) => setSelectedCategory(e.target.value as string)}
            value={selectedCategory}
            error={!!errors.categories}
          >
            {filteredCategories.map((oC: any) => {
              return oC.id !== category?.id ? (
                <MenuItem
                  value={oC.id}
                  key={oC.id}
                  className={clsx(classes.categoryMenu, oC.type)}
                >
                  <Checkbox
                    checked={
                      oC.id === selectedCategory ||
                      oC.id === parentSelectedCategory
                    }
                    color="primary"
                    inputProps={{ "aria-label": "secondary checkbox" }}
                  />
                  {oC.title}
                </MenuItem>
              ) : null;
            })}
          </Select>
          {!selectedCategory.length && (
            <span className="PlaceHolderText">
              <Text>Sélectionnez la catégorie de rattachement hihi</Text>
            </span>
          )}
          <Text className={classes.errorField}>
            {errors.categories &&
              (errors.categories.message as unknown as string)}
          </Text>
          <div className={classes.selectedCategories}>
            {categories
              .filter(
                (oC: any) =>
                  selectedCategory === oC.id || parentSelectedCategory === oC.id
              )
              .map((oC: any) => (
                <MuiButton
                  key={oC.id}
                  className={clsx(classes.categoryMenu, oC.type)}
                  onClick={category ? () => {} : () => handleRemoveCategory()}
                  startIcon={!category && <CloseLineIcon />}
                >
                  {oC.title}
                </MuiButton>
              ))}
          </div>
        </FormControl>
      )}
    />
  );
};
